import { useMutation, useQueryClient } from '@tanstack/react-query'
import { crudDispositivosApi } from '../actions/dispositivosApi.jsx';
import { useAppStore } from '../store/appStore.tsx';



export function useDispositivosMutation() {
    const queryClient = useQueryClient();
    const currentUser = useAppStore(appStore => appStore.currentUser);
    //console.log(currentUser);

    return useMutation({
        /*  Nota:
            La forma de acceder a los datos implicitamente enviados en un una funcion como es mutate de Tankstack es
            colocando una función anonima que recién llame nuestra función API, es decir:
                (datosAAcceder) => { funcionApi(datosAAcceder)}
            Se coloca async antes de la funcion anomima y await en la función API porque de lo contrario, sin esperar
            respuesta del servidor se ejecuta el refresh de datos de tankstackQuery
        */
        mutationFn: async (body) => {
            body = { ...body, token: currentUser.token };
            //console.log(body);
            const resp = await crudDispositivosApi(body);
            return resp;
        },
        onSuccess: (mutationResponse) => {
            queryClient.invalidateQueries({ queryKey: ['dispositivos'] });
            //console.log(mutationResponse.result);
            //console.log('Dispositivo creado correctamente con id: ', mutationResponse.data.result.insertId);
        },
        onError: (error) => {
            //console.log('Error Msg: ', error);
            queryClient.invalidateQueries({ queryKey: ['dispositivos'] });
            throw new Error(error);
        }
    })
}

export function useDeleteDispositivo() {
    /*
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: deleteDispositivo,
  
      onSuccess() {
        queryClient.invalidateQueries({ queryKey: ['dispositivos'] })
        //console.log('Dispositivo eliminado 🎉')
      },
    })
    */
}

